import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { IUploadService } from './upload-service.interface';

export const DataAccessUploadService = new InjectionToken<IUploadService>(
  'IDataAccessUploadService',
);

export interface UploadServiceUseClass extends ClassSansProvider {
  useClass: Type<IUploadService>;
}

export interface UploadServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => IUploadService;
}

export type UploadServiceProvider =
  | UploadServiceUseFactory
  | UploadServiceUseClass;

export function provideDataAccessUploadService(config: UploadServiceProvider) {
  return {
    provide: DataAccessUploadService,
    ...config,
  };
}
